module.exports = __webpack_public_path__ + "img/vip_dialog_tb_item_sel.0b16fdb2.png";